/*!
 *   Copyright 2022-2025 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

@import "../../scss/vars";

:host {
  display: block;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  .png-wrapper {
    display: block;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .chart-wrapper {
    position: absolute;
    z-index: 1;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    opacity: 0.5;

    & > div {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .display-container {
    text-align: center;
    justify-items: stretch;
    display: flex;
    overflow: hidden;
    color: var(--warp-view-font-color, $w10-charcoal);
    width: 100%;
    height: 100%;
    z-index: 2;
    position: absolute;
    align-items: stretch;
    justify-content: start;
    min-height: 0;

    &.pos-n {
      align-items: start;
      justify-content: center;
    }

    &.pos-ne {
      align-items: start;
      justify-content: end;
    }

    &.pos-nw {
      align-items: start;
      justify-content: start;
    }

    &.pos-s {
      align-items: end;
      justify-content: center;
    }

    &.pos-se {
      align-items: end;
      justify-content: end;
    }

    &.pos-sw {
      align-items: end;
      justify-content: start;
    }

    &.pos-e {
      align-items: center;
      justify-content: end;
    }

    &.pos-w {
      align-items: center;
      justify-content: start;
    }

    &.pos-c {
      align-items: center;
      justify-content: center;
    }

    .value {
      white-space: nowrap;
      overflow: hidden;
      display: flex;
      font-size: var(--warp-view-font-size, 5rem);
      align-items: baseline;
      margin-bottom: 10px;
      padding: 10px;

      span {
        min-height: 100%;
        max-width: 100% !important;
        width: 100%;
      }

      small {
        font-size: 50%;
      }
    }

    &.display-md {
      text-align: start !important;
      align-items: start;
      justify-content: start;
      overflow: auto;
      width: calc(100% - 10px);
      font-size: var(--warp-view-font-size, 14px) !important;

      > .value {
        width: 100%;
        font-size: var(--warp-view-font-size, 14px) !important;
      }

      table {
        margin-top: 10px;
        margin-bottom: 10px;
      }

      table, th, td {
        border: 1px solid;
        border-color: var(--warp-view-font-color, #404040);
        border-collapse: collapse;
        padding: var(--warp-view-datagrid-cell-padding, 5px);
      }

      pre {
        font-size: 0.8rem;
        background-color: var(--warp-view-md-code-bg, #404040);
        color: var(--warp-view-md-code-font-color, #ffffff);
        padding: 10px;
        margin-right: 10px;
      }
    }

    img {
      max-width: 100% !important;
    }


  }
}
